<template>
    <div>
        <div class="row page-titles">
            <div class="col-sm-6 col-8 align-self-center">
                <h3 class="text-themecolor m-b-0 m-t-0">Blank</h3>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/home">Home</router-link></li>
                    <li class="breadcrumb-item active">Blank</li>
                </ol>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
        },
        data() {
            return {
            }
        }
    }
</script>
